import { BookSerializersBookByline, ReadingJournalSerializersJournal, UserSerializersUserByline } from "types/serializers";
import JournalEventMap from "./events";
import DefaultEventComponent from "./events/DefaultEventComponent";

export default function ReadingJournalEntryEvent({
  journal,
  book,
  user,
}: {
  journal: ReadingJournalSerializersJournal;
  book: BookSerializersBookByline
  user: UserSerializersUserByline;
}) {
  const JournalEntryEventComponent =
    JournalEventMap[journal.event] || DefaultEventComponent;

  return (
    <JournalEntryEventComponent journal={journal} book={book} user={user} />
  );
}
